<template>
    <div class="page-index">
        <div class="hd">
            <div class="bg"></div>
        </div>
        <div class="bd">
            <div class="box">
                <div class="box-hd">
                    <div class="box-hd-label">订单总额</div>
                    <div class="box-hd-value">{{ totalFee }}元</div>
                </div>
                <div class="box-bd">
                    <div class="box-item">
                        <div class="box-bd-label">科室</div>
                        <div class="box-bd-value">{{ deptName }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">病人姓名</div>
                        <div class="box-bd-value">{{ name }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">支付类型</div>
                        <div class="box-bd-value">{{ payType }}</div>
                    </div>
                </div>
            </div>
            <div class="bd-append">
                <i class="bd-append-icon"></i>
                <div class="bd-append-text">医保移动支付</div>
            </div>
        </div>
        <div class="ft">
            <van-button type="primary" round block @click="doPay()">本人医保</van-button>
            <van-button type="primary" style="margin-top: 10px" round block @click="doPay1()">亲情账户</van-button>
        </div>
    </div>
</template>

<script>

    import {getQueryString} from "../../utils/common";
    import {getOrderInfo, token} from "../../api/Api";
    import {Toast} from "vant";
    import md5 from 'js-md5';
    import Constant from "../../utils/Constant";

    export default {
        name: 'PageIndex',
        data() {
            return {
                openId: '',
                totalFee: '',
                deptName: '',
                name: '',
                payType: '',
                medOrgOrd: '',
                idNo: '',
            }
        },
        methods: {
            doPay() {
                console.log("进行支付授权")
                console.log("medOrgOrd", this.medOrgOrd)
                window.location.href = "https://card.wecity.qq.com/oauth/code?authType=2&isDepart=2" +
                    "&appid=wxbbbf21ec24a1b219&cityCode=654000&channel=AAF6rdbKBBhRyhHE9tQ3QdDs" +
                    "&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxsx1MunG//RTCcmH7CftmAe&orgCodg=H65400200247&bizType=04107&orgAppId=1HEMUSP0101P75430B0A000051FC0B7D" +
                    "&redirectUrl=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fsdsp%2Fmipp%2Fauth%2FauthCallBack/" + this.medOrgOrd + "/1";
            },
            doPay1() {
                console.log("测试中，请勿使用！")
                console.log("身份证号：" + this.idNo)
                console.log("姓名：" + this.name)
                console.log("计算MD5：" + this.name + this.idNo.substring(this.idNo.length - 4, this.idNo.length) + "结果：" + md5(this.name + this.idNo.substring(this.idNo.length - 4, this.idNo.length)))
                let familyid = md5(this.name + this.idNo.substring(this.idNo.length - 4, this.idNo.length))
                // let url = "https://card.wecity.qq.com/oauth/code?authType=2&isDepart=2&bizType=04107&appid=wxbbbf21ec24a1b219&cityCode=654000&channel=AAF6rdbKBBhRyhHE9tQ3QdDs" +
                //     "&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK%2FF2LjZPYJ81nK2eYQqxsx1MunG%2F%2FRTCcmH7CftmAe&familyid=" + familyid + "&orgCodg=H65400200247&orgAppId=1HEMUSP0101P75430B0A000051FC0B7D" +
                //     "&redirectUrl=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fsdsp%2Fmipp%2Fauth%2FauthCallBack%2F" + this.medOrgOrd + "%2F2";
                let url = "https://card.wecity.qq.com/oauth/code?authType=2&isDepart=2&bizType=04107&appid=wxbbbf21ec24a1b219&cityCode=654000&channel=AAF6rdbKBBhRyhHE9tQ3QdDs&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK%2FF2LjZPYJ81nK2eYQqxsx1MunG%2F%2FRTCcmH7CftmAe&familyId=" + familyid + "&orgCodg=H65400200247&orgAppId=1HEMUSP0101P75430B0A000051FC0B7D&redirectUrl=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fsdsp%2Fmipp%2Fauth%2FauthCallBack%2F" + this.medOrgOrd + "%2F2"
                // alert("授权URL：" + url)
                window.location.href = url;
            }
        },
        mounted: function () {
            this.$nextTick(async function () {
                window.document.title = "医保移动支付";
                Toast.loading({
                    message: '查询中...',
                    duration: 0
                });
                this.medOrgOrd = getQueryString("medOrgOrd")
                this.openId = getQueryString("openId")
                console.log("openId", this.openId)
                this.$store.commit('setOpenId', this.openId)
                let res = await token({
                    openId: this.openId,
                    termNo: Constant.TermInfo.termNo,
                    termType: Constant.TermInfo.termType,
                    resourceType: '3'
                })
                if (res.status !== 200) {
                    console.log('get token 500')
                    throw new Error('系统异常，请稍后再试');
                }
                this.$store.commit('saveToken', res.data);

                let p = {
                    medOrgOrd: this.medOrgOrd,
                }
                let ret = await getOrderInfo(p);
                Toast.clear();
                if (ret.status !== 200) {
                    Toast.fail("查询订单信息失败！")
                    return;
                }
                this.totalFee = ret.data.totalFee
                this.deptName = ret.data.deptName
                this.name = ret.data.name
                this.payType = ret.data.payType
                this.idNo = ret.data.idNo
            })
        }
    }
</script>

<style scoped>
    @import '../../assets/index.css';
    @import '../../assets/actionsheet.css';

    .van-button--primary {
        color: #fff;
        background-color: #1989fa;
        border: 1px solid #1989fa;
    }
</style>
